import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Snackbar from '@material-ui/core/Snackbar';
import Avatar from '@material-ui/core/Avatar';
import * as messages from '../../../messages';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom'
import axios from '../../../axios-ns';
import Aux from '../../../hoc/Aux';
import Spinner from '../../../components/UI/Spinner/Spinner';

class Dashboard extends Component {

    state = {
        message: null,
        loading: true
    }

    componentDidMount() {
        axios.post('protected/products/add-new-products', null, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(response => {
                if (response.data.productAdded == true) {
                    this.setState({ ...this.state, message: 'Sprawdź listę Twoich usług. Dodaliśmy nową usługę!' });
                    setTimeout(() => { this.setState({ ...this.state, message: null }); }, 20000)
                } else {
                    axios.get('protected/messages', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                        .then(response => {
                            this.setState({ ...this.state, message: response.data });
                            setTimeout(() => { this.setState({ ...this.state, message: null }); }, 20000)
                        })
                }
            });

            //Lista moich produktów - dynamiczny content w zależności od dostępnych produktów
            if (localStorage.getItem('token')) {
                axios.get('protected/products/my', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                    .then(response => {
                        this.setState({ trainings: response.data, loading: false });
                    }).catch(err => {
                        this.setState({ ...this.state, loading: false });
                    })
            }
    
    }

    render() {
        let content = null;

        if(this.state.trainings != null && this.state.trainings.find(t => t.productCode === 'SPS' && !t.evaluationStatus)) {
            let transactionCode = this.state.trainings.find(t => t.productCode === 'SPS' && t.evaluationStatus != 'EVALUATED').transactionCode;

            content = (<Aux><p><img src="https://nauka-spiewu.pl/assets/images/pw/pw_welcome.JPG" style={{ width: '100%', maxWidth: '500px', float: 'center', marginTop: '20px', marginBottom: '20px' }} /></p>
            <div dangerouslySetInnerHTML={{ __html: messages.DASHBOARD_SPS }}></div>
            <p style={{ textAlign: 'center' }}>
                <Button style={{ display: 'inline-block', marginRight: '10px', backgroundColor: 'orange' }} variant="contained" size="small" color="primary" component={Link} to={'/protected/training/' + transactionCode}>
                    Rozpocznij weryfikację wokalną
                </Button>
            </p></Aux>);
        } else {
            content = (<Aux><p><img src="https://nauka-spiewu.pl/assets/images/pw/pw_welcome.JPG" style={{ width: '100%', maxWidth: '500px', float: 'center', marginTop: '20px', marginBottom: '20px' }} /></p>
            <div dangerouslySetInnerHTML={{ __html: messages.DASHBOARD }}></div>
            <p style={{ textAlign: 'center' }}>
                <Button style={{ display: 'inline-block', marginRight: '10px', backgroundColor: 'orange' }} variant="contained" size="small" color="primary" component={Link} to={'/protected/products'}>
                    {messages.SEE_RECOMMENDED_PRODUCTS}
                </Button>
                <Button style={{ display: 'inline-block', backgroundColor: '#252e4a' }} variant="contained" size="small" color="primary" component={Link} to={'/protected/my-trainings'}>
                    {messages.SEE_MY_COURSES}
                </Button>
            </p></Aux>);
        }

        let view = this.state.loading ? <Spinner/> : <Card style={{ padding: '10px' }}>
        <b>{messages.WELCOME}</b>
        {content}
        <Snackbar open={this.state.message} anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
            autoHideDuration={3000}
            variant="success"
            message={<span dangerouslySetInnerHTML={{ __html: this.state.message }}></span>} />
    </Card>;

        return view;

    };
}

export default Dashboard;